import { Button, Typography } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import axios from "axios";
import React, { Component } from "react";
import Modal from "react-awesome-modal";
import { API } from "../Constants/APIs";
import init from "../Helpers/Windotoken";

export default class ProductCard extends Component {
  state = {
    product0: [],
    some: "",
    Variants: [],
    productId: 0,
    query: "",
  };
  componentDidMount() {
    // console.log(this.props);
    this.getVariants();
    // axios.get(API.getUrls.getProducts).then((resp) => {
    // //    console.log(resp);
    // })
  }
  getVariants = () => {
    axios
      .get(API.getUrls.variants + "?page=1&limit=10&product=" + this.props.id)
      .then((res) => {
        this.setState({
          Variants: res.data.docs,
        });
      });
  };
  openeditLink = () => {
    if (this.state.Variants.length > 0) {
      window.location.href = "/viewer" + "?id=" + this.props.id;
    } else {
      window.location.href = "/product-edit" + "?id=" + this.props.id;
    }
  };
  deleteProduct = (pId) => {
    // this.props.onDelete(this.props.catId);
    // return;
    if (init() === "success") {
      axios.delete(API.postUrls.addproduct + "/" + pId).then((res) => {
        if (res.data.status === "success") {
          this.setState({
            notification: true,
            successMsg: res.data.message,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              openModal: false,
            });
            this.props.onDelete(this.props.catId, this.props.CardIndex);
          }, 3000);
        } else {
          this.setState({
            notification: true,
            successMsg: res.data.message,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              openModal: false,
            });
          }, 2000);
        }
      });
    }
  };

  fetchModels = () => {
    if (this.props.catId) {
      if (init() === "success") {
        axios
          .get(
            API.getUrls.getProducts +
              "?page=" +
              this.props.page +
              "&limit=" +
              this.props.limit +
              "&catId=" +
              this.props.catId +
              "&q=" +
              this.props.query +
              "&status=" +
              this.props.status
          )
          .then((res) => {
            this.setState({
              loadingProducts: false,

              ["products" + this.props.CardIndex]: res.data.docs,
              totalpage: res.data.totalPages,
              hasNextPage: res.data.hasNextPage === false ? false : true,
            });
          });
      }
    }
  };
  render() {
    const props = this.props;
    return (
      <div className="productCard" style={{ position: "relative" }}>
        <div className="imgBackground" onClick={() => this.openeditLink()}>
          <div className="imgWrapper">
            <img src={props.imgSrc} alt={props.title} />
          </div>
        </div>

        <div
          style={{
            padding: "16px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography className="bold modelTitle">{props.title}</Typography>

          <DeleteOutlineIcon
            className="deleteIcon"
            onClick={() => {
              this.setState({
                openModal: true,
                productId: props.id,
              });
            }}
          />
        </div>
        {props.views ? (
          <Typography
            className=" modelviews"
            style={{ paddingLeft: "16px", marginTop: "-26px" }}
          >
            Views : {props.views}
          </Typography>
        ) : (
          <Typography
            className=" modelviews"
            style={{ paddingLeft: "16px", marginTop: "-26px" }}
          >
            Views : 0
          </Typography>
        )}
        <br />
        {props.publishStatus === "published" ? (
          <Typography
            className="published"
            style={{ marginTop: "-20px", fontSize: "14px" }}
          >
            Published
          </Typography>
        ) : (
          <Typography
            className="published"
            style={{ marginTop: "-20px", fontSize: "14px" }}
          >
            Not Published
          </Typography>
        )}
        <Modal
          visible={this.state.openModal}
          width="400"
          height="300"
          effect="fadeInUp"
          onClickAway={() => this.setState({ openModal: false })}
        >
          <div className="confirmationModal" style={{ textAlign: "center" }}>
            <Typography>
              Are you sure you want to delete this product ?
            </Typography>
            <Button
              onClick={() => {
                this.deleteProduct(this.state.productId);
              }}
              className="DeleteBtn"
            >
              Delete{" "}
            </Button>
            <Button
              onClick={() => this.setState({ openModal: false })}
              className="DeleteBtn"
              style={{ background: "#bdbdbd" }}
            >
              Cancel
            </Button>
            <p style={{ color: "green", textTransform: "capitalize" }}>
              {this.state.notification ? this.state.successMsg : ""}{" "}
            </p>
          </div>
        </Modal>
      </div>
    );
  }
}
